import { render, staticRenderFns } from "./SettingsRMAConfigView.vue?vue&type=template&id=11b45612&scoped=true&"
import script from "./SettingsRMAConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsRMAConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b45612",
  null
  
)

export default component.exports